(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-combined"]) return;
  try {
    
// Store the original price when the page loads
let originalPrice;

// Use event delegation for dynamically loaded add-on options
document.addEventListener('click', function(event) {
  const clickedElement = event.target.closest('.addon-option');
  if (clickedElement) {
    // Remove selected state from all options in the same container
    const container = clickedElement.closest('.product__add-on');
    if (container) {
      container.querySelectorAll('.addon-option').forEach(opt => {
        opt.removeAttribute('addon-selected');
        opt.setAttribute('addon-not-selected', '');
      });
      
      // Add selected state to clicked option
      clickedElement.removeAttribute('addon-not-selected');
      clickedElement.setAttribute('addon-selected', '');
      
      // Update price
      updatePriceWithAddOn();
    }
  }
});

// Listen for variant changes
document.addEventListener('change', function(event) {
  if (event.target.closest('variant-selects')) {
    // Small timeout to ensure variant price is updated first
    setTimeout(updatePriceWithAddOn, 100);
  }
});

function getCurrentVariantPrice() {
  const variantSelects = document.querySelector('variant-selects');
  if (variantSelects) {
    const variantsJson = JSON.parse(variantSelects.querySelector('script[type="application/json"]').textContent);
    const selectedInputs = variantSelects.querySelectorAll('input[type="radio"]:checked');
    
    const selectedOptions = Array.from(selectedInputs).map(input => input.value);
    
    const currentVariant = variantsJson.find(variant => 
      selectedOptions.every(option => variant.options.includes(option))
    );
    
    if (currentVariant) {
      return {
        price: currentVariant.price,
        compareAtPrice: currentVariant.compare_at_price
      };
    }
  }
  return null;
}

function updatePriceWithAddOn() {
  const variantPrices = getCurrentVariantPrice();
  if (!variantPrices) return;
  
  const selectedAddOn = document.querySelector('.addon-option[addon-selected]');
  
  let finalPrice = variantPrices.price;
  let finalCompareAtPrice = variantPrices.compareAtPrice;
  
  if (selectedAddOn && selectedAddOn.dataset.variantPrice) {
    const addOnPrice = parseInt(selectedAddOn.dataset.variantPrice, 10);
    finalPrice = variantPrices.price + addOnPrice;
    if (finalCompareAtPrice) {
      finalCompareAtPrice = variantPrices.compareAtPrice + addOnPrice;
    }
  }

  // Get the price container
  const priceContainer = document.querySelector('.price__container');
  if (!priceContainer) return;

  // Add or remove sale class from parent
  const priceParent = priceContainer.closest('.price');
  if (priceParent) {
    if (finalCompareAtPrice && finalCompareAtPrice > finalPrice) {
      priceParent.classList.add('price--on-sale');
    } else {
      priceParent.classList.remove('price--on-sale');
    }
  }

  // Update regular price
  const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
  if (regularPriceElement) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      regularPriceElement.innerHTML = Shopify.formatMoney(finalPrice);
    } else {
      regularPriceElement.innerHTML = `$${(finalPrice / 100).toFixed(2)}`;
    }
  }

  // Update sale prices if there's a compare-at price
  if (finalCompareAtPrice && finalCompareAtPrice > finalPrice) {
    // Update compare-at price
    const compareAtPriceElement = priceContainer.querySelector('.price__sale .price-item--regular .money');
    if (compareAtPriceElement) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        compareAtPriceElement.innerHTML = Shopify.formatMoney(finalCompareAtPrice);
      } else {
        compareAtPriceElement.innerHTML = `$${(finalCompareAtPrice / 100).toFixed(2)}`;
      }
    }

    // Update sale price
    const salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale .money');
    if (salePriceElement) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        salePriceElement.innerHTML = Shopify.formatMoney(finalPrice);
      } else {
        salePriceElement.innerHTML = `$${(finalPrice / 100).toFixed(2)}`;
      }
    }
  }
}

// Initial price setup
document.addEventListener('DOMContentLoaded', function() {
  originalPrice = getCurrentVariantPrice();
  updatePriceWithAddOn();
});
  
document.getElementById('productSection').addEventListener('change', function(event) {
    const optionValueElement = event.target;

    // Handle Colour changes (product switching)
    if (optionValueElement.tagName === 'INPUT' && optionValueElement.type === 'radio' && optionValueElement.name === 'Colour') {
        const productElement = this.querySelector('.product');
        const sectionId = this.dataset.sectionId;
        const oldProductUrl = productElement.dataset.productUrl;
        const newProductUrl = optionValueElement.dataset.productUrl;
        const newVariantId = optionValueElement.dataset.variantId;

        let params = `section_id=${sectionId}&`;
        if (newVariantId) {
            params += `variant=${newVariantId}`;
        } else {
            const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
            params += `option_values=${selectedOptionValues}`;
        }

        fetch(`${newProductUrl}?${params}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                if (newProductUrl && oldProductUrl !== newProductUrl) {
                    productElement.parentNode.insertBefore(html.querySelector('.product'), productElement);
                    productElement.remove();
                    this.querySelector(`#${optionValueElement.id}`).focus();

                    // Update URL with new variant
                    const newUrl = `${newProductUrl}?variant=${newVariantId}`;
                    window.history.replaceState({ path: newUrl }, '', newUrl);

                    // Get variants data and log it
                    const variantScript = this.querySelector('variant-selects script');
                    console.log('Variant Script found:', variantScript);
                    
                    if (variantScript) {
                        const variants = JSON.parse(variantScript.textContent);
                        console.log('Parsed Variants:', variants);
                        
                        peppySelectedOrFirstAvailableVariant = variants.find(variant => 
                            variant.id.toString() === newVariantId) || variants[0];
                        
                        peppyProductName = peppySelectedOrFirstAvailableVariant.name.split(' - ')[0];
                        
                        const urlParts = newProductUrl.split('/');
                        const productHandle = urlParts[urlParts.length - 1];
                        peppyProductId = productHandle;
                        
                        peppyVariantList = variants;
                        
                        peppyVariantInventoryDetailsMap = {};
                        variants.forEach(variant => {
                            peppyVariantInventoryDetailsMap[variant.id] = {
                                inventory_policy: variant.inventory_policy || "deny",
                                inventory_quantity: variant.inventory_quantity || 0
                            };
                        });

                        console.log('Updated PeppyDuck Variables:', {
                            selectedVariant: peppySelectedOrFirstAvailableVariant,
                            productName: peppyProductName,
                            productId: peppyProductId,
                            variantList: peppyVariantList,
                            inventoryMap: peppyVariantInventoryDetailsMap
                        });

                        if (typeof peppyButtonFunction === 'function') {
                            console.log('Calling peppyButtonFunction');
                            peppyButtonFunction();
                        } else {
                            console.log('peppyButtonFunction is not available');
                        }
                    }
                    return;
                }

                this.querySelector('.optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;
                this.querySelector(`#${optionValueElement.id}`).focus();
            });
    }
    // Handle Size changes
    else if (optionValueElement.tagName === 'INPUT' && optionValueElement.type === 'radio' && optionValueElement.name === 'Size') {
        // Update URL with the new variant ID if available
        if (optionValueElement.dataset.variantId) {
            const newUrl = `${window.location.pathname}?variant=${optionValueElement.dataset.variantId}`;
            window.history.replaceState({ path: newUrl }, '', newUrl);
        }
    }
});

(function() {
  // Function to check if URL has the notify-me parameter
  function hasNotifyMeParameter() {
    return window.location.href.indexOf('?open-notify-me') > -1;
  }

  // Function to find and click ONLY the Peppy notify me button
  function clickNotifyMeButton() {
    // Only look for peppy buttons
    const button = document.querySelector('#peppy-notify-me-button');
    const wrapper = document.querySelector('#peppy-notify-me-button-wrapper');
    
    if (button) {
      console.log('Peppy Notify Me button found, preparing to click...');
      
      // First check if the button is fully loaded and visible
      if (isElementVisible(button) && isButtonEnabled(button)) {
        console.log('Button is visible and enabled, clicking...');
        
        try {
          // Set up form submission prevention
          preventAllFormSubmissions();
          
          // First try a direct click to allow event handlers to run
          button.click();
          
          // If there's a wrapper, click that too
          if (wrapper) {
            wrapper.click();
          }
          
          // If the modal dialog is triggered by a custom handler
          // wait a bit and then try triggering known modal methods
          setTimeout(() => {
            tryTriggerModalMethods();
          }, 500);
          
          return true;
        } catch (e) {
          console.error('Error clicking button:', e);
        }
      } else {
        console.log('Button found but not ready yet (either not visible or not enabled)');
      }
    }
    return false;
  }
  
  // Add global form submission prevention
  function preventAllFormSubmissions() {
    console.log('Setting up form submission prevention');
    
    // Prevent all forms from submitting
    document.querySelectorAll('form').forEach(form => {
      // Backup original submit
      if (!form._originalSubmit) {
        form._originalSubmit = form.submit;
        
        // Override submit method
        form.submit = function() {
          console.log('Form submission prevented by notify-me script');
          return false;
        };
        
        // Add event listener for submit events
        form.addEventListener('submit', function(e) {
          console.log('Form submit event prevented');
          e.preventDefault();
          e.stopPropagation();
          return false;
        }, true);
      }
    });
    
    // Handle dynamic form creation by watching for new forms
    const formObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.tagName && node.tagName.toLowerCase() === 'form') {
              preventAllFormSubmissions();
            }
          });
        }
      }
    });
    
    formObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Try to trigger modal functionality
  function tryTriggerModalMethods() {
    // Common modal opening methods and properties
    const modalTriggers = [
      // Peppy specific methods
      'PeppyNotifyMe',
      'peppyNotifyModal',
      'peppyModal',
      'openNotifyModal',
      'showNotifyModal',
      // Generic modal methods
      'openModal',
      'showModal',
      'toggleModal'
    ];
    
    // Look for these methods in the global scope and call them
    for (const method of modalTriggers) {
      if (typeof window[method] === 'function') {
        console.log(`Found modal method: ${method}, trying to call it`);
        try {
          window[method]();
        } catch (e) {
          console.log(`Error calling ${method}:`, e);
        }
      } else if (window[method]) {
        console.log(`Found modal object: ${method}, trying to open it`);
        try {
          // Try different methods on the object
          const obj = window[method];
          if (typeof obj.open === 'function') obj.open();
          if (typeof obj.show === 'function') obj.show();
          if (typeof obj.toggle === 'function') obj.toggle();
        } catch (e) {
          console.log(`Error using ${method} object:`, e);
        }
      }
    }
    
    // Also look for modal elements and try to show them directly
    const modalSelectors = [
      '#peppy-notify-me-modal',
      '.peppy-notify-me-modal',
      '[data-notify-modal]',
      '.notify-modal',
      '.modal[aria-hidden="true"]'
    ];
    
    for (const selector of modalSelectors) {
      const modal = document.querySelector(selector);
      if (modal) {
        console.log(`Found modal element with selector: ${selector}, trying to show it`);
        try {
          // Try to show the modal by updating common modal properties
          modal.style.display = 'block';
          modal.classList.add('show', 'active', 'open');
          modal.classList.remove('hide', 'hidden');
          modal.setAttribute('aria-hidden', 'false');
        } catch (e) {
          console.log(`Error showing modal with selector ${selector}:`, e);
        }
      }
    }
  }
  
  // Helper function to check if an element is visible
  function isElementVisible(element) {
    if (!element) return false;
    
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && 
           style.visibility !== 'hidden' && 
           style.opacity !== '0' &&
           element.offsetWidth > 0 &&
           element.offsetHeight > 0;
  }
  
  // Helper function to check if a button is enabled (not disabled)
  function isButtonEnabled(button) {
    return !button.disabled && !button.classList.contains('disabled');
  }

  // Function to check for the button repeatedly
  function waitForButtonAndClick() {
    // Try to find and click the button immediately
    if (clickNotifyMeButton()) {
      return;
    }

    console.log('Waiting for Peppy Notify Me button to appear...');
    
    // Set up a mutation observer to watch for changes in the DOM
    const observer = new MutationObserver((mutations) => {
      if (clickNotifyMeButton()) {
        observer.disconnect();
      }
    });
    
    // Start observing the document body for DOM changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Also set a backup timer to try again every second for 30 seconds
    let attempts = 0;
    const maxAttempts = 30; // 30 seconds total
    
    const intervalId = setInterval(() => {
      attempts++;
      console.log(`Attempt ${attempts} of ${maxAttempts} to find and click the button...`);
      
      if (clickNotifyMeButton()) {
        console.log('Successfully clicked the Peppy button');
        clearInterval(intervalId);
      } else if (attempts >= maxAttempts) {
        console.log('Peppy button not found after maximum attempts');
        clearInterval(intervalId);
      }
    }, 1000);
  }

  // Check if we should activate the script
  if (hasNotifyMeParameter()) {
    console.log('?open-notify-me parameter detected in URL');
    
    // Give the page a little time to initialize first
    setTimeout(() => {
      // Wait for the DOM to be fully loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          // Wait a bit longer after the DOM is ready to ensure JavaScript has initialized
          setTimeout(waitForButtonAndClick, 1000);
        });
      } else {
        // Wait a bit to ensure JavaScript has initialized
        setTimeout(waitForButtonAndClick, 1000);
      }
    }, 500);
  } else {
    console.log('No ?open-notify-me parameter detected');
  }
})(); 
  

  } catch(e) { console.error(e); }
})();
})();
